<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_bf2"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('vehicleAccident_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('vehicleAccident_add_button')"
          @click="showModel(false, 'Add')"
        >
          新增
        </el-button>
        <el-button
          v-if="getLimit('vehicleAccident_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="licenseNumber"
          title="车牌号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.licenseNumber"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="实际承运人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="violationPlace"
          title="事故地点"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.violationPlace"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="violationProject"
          title="事故原因"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.violationProject"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="responsibleParty"
          title="责任方"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.responsibleParty"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="remark"
          title="备注"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="listQuery.remark" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="accidentTime"
          title="事故日期"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.accidentTimeRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'accidentTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" width="100">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('vehicleAccident_edit_button')"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="code => showModel(scope.row.code, 'Edit')"
            >
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('vehicleAccident_delete_button')"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelAddFlag"
      title="新增"
      width="600"
      height="600"
      resize
    >
      <compAdd ref="AddRef" :restaurants="restaurants" @hideModel="hideModel" />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="600"
      height="600"
      resize
    >
      <compEdit
        ref="EditRef"
        :restaurants="restaurants"
        @hideModel="hideModel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compAdd from "./components/vehicleAccidentAdd.vue";
import compEdit from "./components/vehicleAccidentEdit.vue";
import { vehicleAccident, delVehicleAccident } from "@/api/vehicleService";
import { vehicle } from "@/api/transport";
export default {
  name: "Parent",
  components: {
    compAdd,
    compEdit
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/vehicleAccident/exportVehicleAccidentList", //导出接口
        name: "车辆事故"
      },
      restaurants: [], // 车辆列表
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modelEditFlag: false,
      partyType: this.$store.getters.party.partyType,
      partyCode: this.$store.getters.party.code,
      listQuery: {
        accidentTimeRange: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      }
    };
  },
  created() {
    if (this.partyType == "DRIVER") {
      vehicle({
        pageSize: 1000000,
        partyCode: this.partyCode,
        branchCodeExt: this.$store.state.user.party.branchCode
      }).then(response => {
        this.restaurants = response.data.records;
      });
    } else if (this.partyType == "DRIVER_LEADER") {
      vehicle({
        pageSize: 1000000,
        teamCode: this.partyCode,
        branchCodeExt: this.$store.state.user.party.branchCode
      }).then(response => {
        this.restaurants = response.data.records;
      });
    } else {
      vehicle({
        pageSize: 1000000,
        branchCodeExt: this.$store.state.user.party.branchCode
      }).then(response => {
        this.restaurants = response.data.records;
      });
    }
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        vehicleAccident(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 展示弹框
    showModel(code, prefix) {
      if (code) {
        this.$refs[`${prefix}Ref`].getInfo(code);
      } else {
        this.$refs[`${prefix}Ref`].init();
      }
      this[`model${prefix}Flag`] = true;
    },
    // 隐藏弹框
    hideModel(tag) {
      this.modelAddFlag = false;
      this.modelEditFlag = false;
      if (tag) {
        this.findList();
      }
    },
    // 删除方法
    funcDelete(codes) {
      this.$confirm("确认删除吗？").then(_ => {
        delVehicleAccident({ codes }).then(response => {
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        });
      });
    },
    // 设置底部合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          return null;
        })
      ];
    }
  }
};
</script>

<style></style>
